import { FormControlLabel, Stack, Switch, Tooltip, Typography } from "@mui/material";

import { useThemePreference } from "../context/ThemePreferenceContext";

const ClientAppearanceForm = () => {
  const { darkThemeEnabled, setDarkThemeEnabled } = useThemePreference();

  return (
    <Stack spacing={2}>
      <Tooltip title="Toggle the UI between light and dark themes for this browser only.">
        <FormControlLabel
          control={
            <Switch
              checked={darkThemeEnabled}
              onChange={(_, checked) => setDarkThemeEnabled(checked)}
              name="darkTheme"
            />
          }
          label="Enable dark theme"
        />
      </Tooltip>
    </Stack>
  );
};

export default ClientAppearanceForm;
